
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/moz",
      function () {
        return require("private-next-pages/customers/moz.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/moz"])
      });
    }
  